import 'element-ui/lib/theme-chalk/icon.css';
import App from './App';
import { createRouter } from './router';
import { createStore } from './store/index';
import { scrollTo } from '@/helper/iframeEvent';

const locales = require.context('./locales/', false, /\.js$/);

console.log(process.env.NODE_ENV);

export default function getAppInitParams () {
  const router = createRouter();
  const store = createStore();

  router.beforeResolve((to, from, next) => {
    if (typeof window !== 'undefined') {
      scrollTo(0);
    }
    next();
  });

  return {
    router,
    store,
    locales,
    App
  };
};



// WEBPACK FOOTER //
// ./src/projects/hsbpc/main.js